/* eslint-disable import/prefer-default-export */
export const CSM_LOGOUT = 'csm-logout';
export const RETAILER_SWITCH = 'retailer-switch';
